import React, { useEffect } from 'react';
import './Timecard.css';
import './TimecardModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import RippleButton from '../ui/rippleButton'

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const TimecardModal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {

  useEffect(() => {
    const handleKeydown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.body.style.overflow = "hidden"
      window.addEventListener('keydown', handleKeydown);
    }

    return () => {
      document.body.style.overflow = "auto"
      window.removeEventListener('keydown', handleKeydown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="timecard-modal-content">
        <button className="modal-close-button fancy-close-button" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        {children}
        <div className="close-button-position">
          <RippleButton
            width={'80px'}
            heihgt={'40px'}
            borderRadius={'8px'}
            onClick={onClose}
            effectSize={160}
            className='bk-secondary'
          >
            <span className="children">閉じる</span>
          </RippleButton>
        </div>
      </div>
    </div>
  );
};

export default TimecardModal;